import { globalEventBus } from '@fiverr-private/futile';

/**
 * Build an emitter function to sends events to BigQuery.
 *
 * @example
 *
 * listener = buildBigQueryEmitter("OBS::BIG_QUERY")
 */
const buildBigQueryEmitter = (event_key) => (...events) => globalEventBus.deferred(event_key, { events });

export default buildBigQueryEmitter;
